// reducers/operationsSupplyChainReducer.js
import {
    SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST,
    SUBMIT_OPERATIONS_SUPPLY_CHAIN_SUCCESS,
    SUBMIT_OPERATIONS_SUPPLY_CHAIN_FAILURE,
  } from "../actions/operationsAndSupplyChainActions";
  
  const initialState = {
    loading: false,
    successMessage: null,
    errorMessage: null,
  };
  
  const operationsSupplyChainReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST:
        return {
          ...state,
          loading: true,
          successMessage: null,
          errorMessage: null,
        };
      case SUBMIT_OPERATIONS_SUPPLY_CHAIN_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: action.payload,
          errorMessage: null,
        };
      case SUBMIT_OPERATIONS_SUPPLY_CHAIN_FAILURE:
        return {
          ...state,
          loading: false,
          successMessage: null,
          errorMessage: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default operationsSupplyChainReducer;